import React, { useState } from 'react';

export default function Header() {
  // Mobile menu ko open/close karne ke liye state
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky-top" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="container py-3 d-flex justify-content-between align-items-center">
        
        {/* Logo & Company Name Section */}
        <div className="d-flex align-items-center gap-3">
          <img 
            src="/logo.png" 
            alt="Divine Solar Energy Logo" 
            style={{ width: '120px', height: 'auto', objectFit: 'contain' }}
            onError={(e) => { 
              e.target.src = 'https://cdn-icons-png.flaticon.com/512/3073/3073665.png'; 
            }} 
          />
          <div>
            <h1 className="h5 fw-bolder mb-0" style={{ color: '#0f2b5b', letterSpacing: '0.5px' }}>
              DIVINE SOLAR ENERGY
            </h1>
            <p className="mb-0 text-warning fw-bold text-uppercase" style={{ fontSize: '9px', letterSpacing: '1.5px' }}>
              Powering a Greener Tomorrow
            </p>
          </div>
        </div>

        {/* Desktop Navigation Links & Button (Hidden on Mobile) */}
        <nav className="d-none d-lg-flex align-items-center gap-4">
          <a href="#home" className="text-secondary text-decoration-none fw-semibold nav-link-custom">Home</a>
          <a href="#about" className="text-secondary text-decoration-none fw-semibold nav-link-custom">About Us</a>
          <a href="#services" className="text-secondary text-decoration-none fw-semibold nav-link-custom">Services</a>
          <a href="#contact" className="text-secondary text-decoration-none fw-semibold nav-link-custom">Contact</a>
          
          <a href="#contact" className="btn btn-warning fw-bold px-4 py-2 rounded-pill shadow-sm ms-2" style={{ color: '#0f2b5b', letterSpacing: '0.5px' }}>
            Get a Quote
          </a>
        </nav>

        {/* Mobile Hamburger Button (Visible only on Mobile) */}
        <button 
          className="btn d-lg-none border-0 shadow-none p-0" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#0f2b5b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            {isMobileMenuOpen ? (
              // Close (X) Icon
              <>
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </>
            ) : (
              // Hamburger (3 lines) Icon
              <>
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </>
            )}
          </svg>
        </button>

      </div>

      {/* Mobile Dropdown Menu */}
      {isMobileMenuOpen && (
        <div className="d-lg-none bg-white border-top position-absolute w-100 shadow-lg" style={{ zIndex: 1000 }}>
          <div className="container py-4 d-flex flex-column gap-3 text-center">
            <a href="#home" onClick={() => setIsMobileMenuOpen(false)} className="text-dark text-decoration-none fw-bold fs-5">Home</a>
            <a href="#about" onClick={() => setIsMobileMenuOpen(false)} className="text-dark text-decoration-none fw-bold fs-5">About Us</a>
            <a href="#services" onClick={() => setIsMobileMenuOpen(false)} className="text-dark text-decoration-none fw-bold fs-5">Services</a>
            <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="text-dark text-decoration-none fw-bold fs-5">Contact</a>
            <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="btn btn-warning fw-bold py-3 mt-2 rounded-3" style={{ color: '#0f2b5b' }}>
              Get a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}